import { Message, messageBannerFunctions, MessageTypes } from '@nhl/nhl-react-ui/lib/MessageBanner';

import * as accountAPI from 'media-base-ui/utils/accountAPI';

import actionCreators from './actionCreators';

const changeTeamSelection = actionCreators.changeTeamSelection;
const changeDivisionSelection = actionCreators.changeDivisionSelection;
const changeSubscriptionFilter = actionCreators.changeSubscriptionFilter;
const changeCategorySelection = actionCreators.changeCategorySelection;
const hydrateSubscriptions = actionCreators.hydrateSubscriptions;

const submitSave = (subscriptionFilter, subscriptionCategories, subscriptionTeams) => async dispatch => {
    dispatch(actionCreators.requestSave());

    try {
        await accountAPI.saveProfile({
            profile: {
                subscriptionFilter,
                subscriptionCategories,
                subscriptionTeams,
            },
            validateProfile: false,
        });

        dispatch(actionCreators.saveResponse(true, []));
        messageBannerFunctions.dispatchMessage(new Message('Email Subscriptions saved successfully!', MessageTypes.SUCCESS));
    } catch (errors) {
        if (!Array.isArray(errors)) {
            saveFailHelper([], dispatch);
            throw errors;
        }

        saveFailHelper(errors, dispatch);
    }
};

const saveFailHelper = (errors, dispatch) => {
    dispatch(actionCreators.saveResponse(false, errors));
    messageBannerFunctions.dispatchMessage(new Message('There were some problems with the form. See below for more details.', MessageTypes.ERROR));
};

const fetchCategories = () => async dispatch => {
    dispatch(actionCreators.requestCategories());

    try {
        const data = await accountAPI.fetchEmailSubscriptionCategories();
        dispatch(actionCreators.categoriesResponse(true, data.data, []))
    } catch (errors) {
        dispatch(actionCreators.categoriesResponse(false, [], errors))
    }
};

export default {
    changeTeamSelection,
    changeDivisionSelection,
    changeSubscriptionFilter,
    changeCategorySelection,
    hydrateSubscriptions,
    submitSave,
    fetchCategories
};